import React from 'react';
import { Input, Button, TitleModalRight } from 'components'; // Eliminamos componentes no usados
import { DiscountService } from 'services';
import { Globals } from 'utils';

interface Props {
	title?: string;
	onClose?: any;
	item?: any; // Mantenemos la prop por compatibilidad, aunque no se use directamente
	user?: any;
}

class CreateDiscountDefault extends React.Component<Props> {

	state = {
		loading: true,
		form: {
			id: null,
			amount: 10, // Valor por defecto solicitado
		}
	}

	async componentDidMount() {
		// Al montar, consultamos la configuración actual
		await this.loadDefaultConfiguration();
	}

	loadDefaultConfiguration = async () => {
		try {
			const response: any = await DiscountService.admin.getDiscountDefault();
			console.log(response)

			if (response && response.amount) {
				this.setState({
					form: {
						amount: response.amount,
						id: response.id, // Guardamos el ID si viene, para futuras actualizaciones
					}
				});
			}
			// Si response es null, el state ya tiene 10 por defecto.
		} catch (error) {
			console.error("Error cargando configuración por defecto", error);
		} finally {
			this.setState({ loading: false });
		}
	}

	submit = async (e: any) => {
		e.preventDefault();
		const { amount, id } = this.state.form;

		// Validación simple antes de enviar
		if (!amount || Number(amount) <= 0) {
			Globals.showError("El monto debe ser un número mayor a 0.");
			return;
		}

		try {
			// Enviamos la nueva configuración.
			// Dado que el backend hace un 'findOne order DESC', asumimos que guardamos un nuevo registro histórico
			// o actualizamos el existente. Usamos un nombre genérico sugerido 'saveDiscountDefault' o 'createDiscountDefault'.
			await DiscountService.admin.createDiscountDefault({
				id: id,
				amount: Number(amount)
			});

			Globals.showSuccess("Configuración actualizada correctamente");
			this.props.onClose();
		} catch (error) {
			console.error(error);
			Globals.showError("No se pudo guardar la configuración");
		}
	}

	change = (e: any) => {
		const { name, value } = e.target;

		// Lógica exclusiva para 'amount': Solo permitir números positivos
		if (name === 'amount') {
			// Regex: Elimina cualquier caracter que no sea número
			const numericValue = value.replace(/[^0-9]/g, '');

			this.setState({
				form: {
					...this.state.form,
					amount: numericValue
				}
			});
		}
	}

	render() {
		// Si está cargando, podrías mostrar un spinner, pero por UX dejamos el input visible con el default
		return (
			<div id="create-discount">
				<TitleModalRight
					title={this.props.title || "Configuración de Descuento"}
					onClose={this.props.onClose}
				/>
				<form className="container-scroll-modal-right" onSubmit={this.submit}>
					<div className="col-md-12">
						<label className="text-white mb-2">Monto por Defecto ($)</label>
						<Input
							type="text" // Usamos text controlado para forzar la regex numérica
							color="white"
							value={this.state.form.amount}
							name="amount"
							className="input-amount"
							placeholder="Ej: 10"
							onChange={this.change}
							// Opcional: maxLength para evitar números irreales
							maxLength={5}
						/>
						<small className="text-muted">
							Este valor se aplicará a los descuentos creados por los clientes.
						</small>
					</div>

					<div className="text-center mt-4">
						<Button type="submit" disabled={this.state.loading}>
							{this.state.loading ? 'Cargando...' : 'Guardar'}
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default CreateDiscountDefault;